import {BRAND_CATEGORY_URL} from "../../helpers/api.routes";
import {requests} from "../../helpers/api.services";
import {IPagination} from "../../shared/interface";

export const AdminBrandCategoryService = {
    getAll: (params: IPagination) => requests.get(`${BRAND_CATEGORY_URL}`, params),
    getSingle: (id: number) => requests.get(`${BRAND_CATEGORY_URL}/${id}`),
    create: (payload: FormData) => requests.post(`${BRAND_CATEGORY_URL}`, payload, true),
    update: (payload: FormData, id: number) => requests.post(`${BRAND_CATEGORY_URL}/${id}`, payload, true),
    updatePosition: (ids: number[]) => requests.patch(`${BRAND_CATEGORY_URL}`, {ids}),
    delete: (id: number) => requests.delete(`${BRAND_CATEGORY_URL}/${id}`),
};
